
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { HelloTongCardType } from '@xt/client/types/home.d'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    LazyImg
  }
})
export default class extends Vue {
  @Prop() dataSource: HelloTongCardType

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
